import $, { css, get } from "jquery";
import "@fancyapps/fancybox";
import Swiper from 'swiper/bundle';
import 'select2';
import "./popup";
// import "masonry-layout/dist/masonry.pkgd.min.js";
// import 'isotope-layout/dist/isotope.pkgd.min.js';


$(function ($) {
    console.log('I am testing!!!');
    const showMenu = (toggleId, navId) => {
        const toggle = document.getElementById(toggleId),
            nav = document.getElementById(navId);
        if (toggle && nav) {
            toggle.addEventListener('click', () => {
                nav.classList.toggle('show');
                document.body.classList.toggle('open-menu');
                // toggle.classList.toggle('bx-x');
            })
        }
    }
    showMenu('header-toggle', 'menu')

    $(window).on('scroll', function () {
        // const top = bar.css('top');
        if ($(this).scrollTop() > 25) {
            $('header').addClass("header__small");
        } else {
            $('header').removeClass("header__small");
        }
    });

    // function initializeHeaderBehavior() {
    //     const $header = $(".header");
    //     const $main = $(".site-content");
    //     const headerHeight = $header.outerHeight();
    //     $main.css("top", headerHeight + "px");

    //     let lastScroll = 0;

    //     $(window).on('scroll', function () {
    //         let currentScroll = $(window).scrollTop();

    //         if (currentScroll > lastScroll) {
    //             // scrolled down
    //             $header.removeClass("header-scroll-up").addClass("header-scroll-down");
    //         } else {
    //             // scrolled up -- header show
    //             $header.removeClass("header-scroll-down").addClass("header-scroll-up");
    //         }

    //         lastScroll = currentScroll;
    //     });

    //     $header.on('mouseover', function () {
    //         // Remove the class that hides the header when mouseover occurs
    //         $header.removeClass("header-scroll-down");
    //     });
    // }

    // // Call the function to initialize header behavior
    // initializeHeaderBehavior();

    const mySwiper = new Swiper('.selling-swiper-container', {
        slidesPerView: 4,
        spaceBetween: 20,
        loop: true,
        delay: 5500,
        autoplay: {
            delay: 5500,
            disableOnInteraction: false,
        },
        breakpoints: {
            1400: {
                slidesPerView: 4,
                spaceBetween: 32,
                navigation: {
                    enabled: true,
                },
            },
            1025: {
                slidesPerView: 3,
                navigation: {
                    enabled: true,
                },
            },
            700: {
                slidesPerView: 2,
                navigation: {
                    enabled: true,
                },
            },
            450: {
                slidesPerView: 1,
                spaceBetween: 20,
                navigation: {
                    enabled: true,
                },
            },
            0: {
                slidesPerView: 1,
                navigation: {
                    enabled: true,
                },
            },
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    })


    const hamburgerList = [
        "#hamburger",
    ];

    hamburgerList.forEach(function (hamburgerId) {
        $(hamburgerId).on("click", function () {
            activateHamburger(this);
        });
    });

    function activateHamburger(el) {
        $(el).children().toggleClass("active");
    }

    $(window).on('scroll resize', function () {
        var fixedBlock = $('.btn-right-fixed');
        var goldBlocks = $('.gold-block');

        var fixedBlockTop = fixedBlock.offset().top;
        var fixedBlockBottom = fixedBlockTop + fixedBlock.outerHeight();

        var isInGoldBlock = false;

        goldBlocks.each(function () {
            var otherBlock = $(this);

            var otherBlockTop = otherBlock.offset().top;
            var otherBlockBottom = otherBlockTop + otherBlock.outerHeight();

            // Check if the fixed block touches or overlaps with the gold block
            if ((fixedBlockTop >= otherBlockTop && fixedBlockTop <= otherBlockBottom) ||
                (fixedBlockBottom >= otherBlockTop && fixedBlockBottom <= otherBlockBottom) ||
                (fixedBlockTop <= otherBlockTop && fixedBlockBottom >= otherBlockBottom)) {
                isInGoldBlock = true;
                return false; // Break out of the loop since the fixed block is touching a gold block
            }
        });

        if (isInGoldBlock) {
            fixedBlock.addClass('scrolled-to');
        } else {
            fixedBlock.removeClass('scrolled-to');
        }
    });
    function initializeSelect2(id) {
        $('#' + id).select2();
    }

    // Usage
    initializeSelect2('type_object');
    initializeSelect2('cpt_operation');
    initializeSelect2('district_settlement');
    initializeSelect2('type_building');
    initializeSelect2('state_object');
    initializeSelect2('coun_room');
    // Function to animate incrementation of numbers
    function animateNumbers() {
        $('.numbers__num').each(function () {
            var $this = $(this);
            var endNumber = parseInt($this.data('number'));
            var startNumber = 0;
            var duration = 4000; // Animation duration in milliseconds

            $({ countNum: startNumber }).animate({ countNum: endNumber }, {
                duration: duration,
                easing: 'linear',
                step: function () {
                    $this.text(Math.floor(this.countNum));
                },
                complete: function () {
                    $this.text(this.countNum);
                }
            });
        });
    }

    // Call the function after the DOM is loaded
    animateNumbers();

    // Reset all Select2 dropdowns and clear their selections
    $('#resetFiltersBtn').on('click', function () {
        $('.search-select').val(null).trigger('change');
        $('#price-from').val(''); // Clear price from input
        $('#price-to').val('');
    });


    var slider = new Swiper('.object-gallery-slider', {
        slidesPerView: 1,
        centeredSlides: true,
        loop: true,
        // loopedSlides: 6,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        autoplay: {
            delay: 5000, // Time between slides in milliseconds (e.g., 5000 = 5 seconds)
            disableOnInteraction: false, // Set to false to keep autoplaying even when user interacts with the slider
        },
    });


    if ($('.single-rent, .single-selling').length) {
        var $sticky = $('.object-sidebar-widget');
        var lastArticles = $('.last-articles');
        var $stickyStopper = $('.last-articles').length ? $('.last-articles') : $('.footer');

        function updateSidebarWidth() {
            return $sticky.width();
        }

        function updateVariables() {
            var stickyTop = $sticky.offset().top;
            var stickOffset = 94;
            var stickyStopperPosition = $stickyStopper.offset().top;
            var stopPoint = stickyStopperPosition - $sticky.outerHeight() - stickOffset - 100;
            var diff = stopPoint + stickOffset;
            return { stickyTop, stickOffset, stickyStopperPosition, stopPoint, diff };
        }

        function handleStickySidebar() {
            var screenWidth = window.innerWidth;
            if (screenWidth >= 992) {
                var { stickyTop, stickOffset, stickyStopperPosition, stopPoint, diff } = updateVariables();
                var sidebarWidth = updateSidebarWidth();

                $(window).on('scroll', function () {
                    var windowTop = $(window).scrollTop();

                    if (stopPoint < windowTop) {
                        $sticky.css({ position: 'absolute', top: diff, width: sidebarWidth });
                    } else if (stickyTop < windowTop + stickOffset) {
                        $sticky.css({ position: 'fixed', top: stickOffset, width: sidebarWidth });
                    } else {
                        $sticky.css({ position: 'absolute', top: 'initial', width: sidebarWidth });
                    }
                });
            }
        }

        handleStickySidebar(); // Call the function initially

        $(window).on('resize', function () {
            handleStickySidebar(); // Call the function whenever window resizes
        });
    }
    $('#contact-tel').on('input', function() {
        $(this).val($(this).val().replace(/\D/g, ''));
    });
});

